<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <app-ds-icon name="close-x" size="icon-size-2" color="var(--color-core-neutral-7)"></app-ds-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<div class="modal-content">
  <h1 class="ds-title-4">{{ 'GROW.performance.reporting.totalNetIncomeModal.BreakdownTitle' | translate }}</h1>

  <div class="breakdown-header">
    <div>
      <h2 class="ds-heading-2">{{ 'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.CompositionTitle' | translate }}</h2>
      <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('netIncome')"></app-ds-icon>
    </div>
    @if (info['netIncome']) {
      @if (income?.mmf_profit > 0) {
        <p
          class="ds-ui-3 ds-color-core-neutral-7"
          [innerHTML]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.TooltipMMFProfit' | translate"
        ></p>
      }
      <p
        class="ds-ui-3 ds-color-core-neutral-7"
        [innerHTML]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.TooltipPrincipal' | translate"
      ></p>
      <p
        class="ds-ui-3 ds-color-core-neutral-7"
        [innerHTML]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.TooltipPrincipal.92' | translate"
      ></p>
      <p
        class="ds-ui-3 ds-color-core-neutral-7"
        [innerHTML]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.TooltipPrincipal.91' | translate"
      ></p>
    }
  </div>

  <div class="breakdown-content">
    @if (income?.mmf_profit > 0) {
      <app-ds-info-row
        [title]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.mmfProfit' | translate"
        [value]="income?.mmf_profit | thousand: accountCurrency"
      ></app-ds-info-row>
    }
    <app-ds-info-row
      [title]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.coupon' | translate"
      [value]="income?.received_interest | thousand: accountCurrency"
    ></app-ds-info-row>
    <app-ds-info-row
      [title]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.accrued' | translate"
      [value]="income?.accrued_interest_at_purchase === 0 ? '-' : (income?.accrued_interest_at_purchase | thousand: accountCurrency)"
    ></app-ds-info-row>
    <app-ds-info-row
      [title]="'GROW.performance.reporting.totalNetIncomeModal.BreakdownSection.income' | translate"
      [value]="income?.income | thousand: accountCurrency"
    ></app-ds-info-row>
    <app-ds-info-row
      [title]="'GROW.performance.reporting.totalNetIncomeModal.SectionIncomeCalculation.fees' | translate"
      [value]="income?.fees_paid | thousand: accountCurrency"
    ></app-ds-info-row>
  </div>

  <app-ds-info-row
    [showCustomContent]="true"
    [customStyle]="'background-color: var(--color-core-brand-3-2); border-top: medium none; padding-left: var(--spacing-3); padding-right: var(--spacing-3); border-radius: var(--spacing-2); margin-bottom: var(--spacing-4);'"
  >
    <ng-template #customContent>
      <div class="project-title">
        <p class="ds-caption-1 ds-color-core-neutral-7">{{ 'GROW.performance.reporting.totalNetIncomeModal.BreakdownTitle' | translate }}</p>
      </div>
      <div class="project-values">
        <p class="ds-caption-1">{{ income?.net_income | thousand: accountCurrency }}</p>
      </div>
    </ng-template>
  </app-ds-info-row>

  <p class="ds-ui-3 ds-color-core-neutral-7 based-on-text">
    <app-ds-link variant="default" (click)="onViewTransactions($event)">
      {{ 'GROW.performance.reporting.totalNetIncomeModal.Link' | translate }}
    </app-ds-link>
  </p>

  @if (income?.projectBreakdown && income?.projectBreakdown.length > 0) {
    <div class="breakdown-header project-breakdown-header">
      <div>
        <h2 class="ds-heading-2">{{ 'GROW.performance.reporting.totalNetIncomeModal.BreakdownSection.ProjectsTitle' | translate }}</h2>
        <app-ds-icon name="info" class="info-icon" color="var(--color-core-neutral-5)" (click)="onShowInfo('perProjectBreakdown')"></app-ds-icon>
      </div>

      @if (info['perProjectBreakdown']) {
        <p
          class="ds-ui-3 ds-color-core-neutral-7"
          [innerHTML]="'GROW.performance.reporting.totalNetIncomeModal.BreakdownSection.TooltipExchangeRate' | translate"
        ></p>
      }
    </div>

    <div class="breakdown-content">
      <app-ds-info-row [showCustomContent]="true" [customStyle]="'border-top: medium none;'">
        <ng-template #customContent>
          <div class="project-title"></div>
          <div class="project-values project-values-header">
            <p class="ds-caption-3 ds-color-core-neutral-7">
              {{ 'GROW.performance.reporting.totalNetIncomeModal.BreakdownSection.Rate' | translate }}
            </p>
            <p class="ds-caption-3 ds-color-core-neutral-7">
              {{ 'GROW.performance.reporting.totalNetIncomeModal.BreakdownSection.Income' | translate }}
            </p>
          </div>
        </ng-template>
      </app-ds-info-row>

      @for (item of income.projectBreakdown; track item.impact_project_title) {
        <app-ds-info-row [showCustomContent]="true">
          <ng-template #customContent>
            <div class="project-title">
              <p class="ds-ui-2 ds-color-core-neutral-7">{{ item.impact_project_title }}</p>
            </div>
            <div class="project-values project-values-row">
              <p class="ds-ui-2 ds-color-core-neutral-7">{{ item.received_interest ?? 0 | number: '1.2-2' }}</p>
              <p class="ds-ui-2 ds-color-core-neutral-10">{{ item.income ?? 0 | number: '1.2-2' }}</p>
            </div>
          </ng-template>
        </app-ds-info-row>
      }
    </div>

    <app-ds-info-row
      [showCustomContent]="true"
      [customStyle]="'background-color: var(--color-core-brand-3-2); border-top: medium none; padding-left: var(--spacing-3); padding-right: var(--spacing-3); border-radius: var(--spacing-2);'"
    >
      <ng-template #customContent>
        <div class="project-title">
          <p class="ds-caption-1 ds-color-core-neutral-7">
            {{ 'GROW.performance.reporting.totalNetIncomeModal.BreakdownSection.income' | translate }}
          </p>
        </div>
        <div class="project-values">
          <p class="ds-caption-1">{{ income.income | thousand: accountCurrency }}</p>
        </div>
      </ng-template>
    </app-ds-info-row>
  }
</div>
